module.exports = __webpack_public_path__ + "static/media/jajce.cc3f2009.jpg";